import { Page } from '../../components'
import { ChatPageDetails } from '../../components/ChatServices/ChatPageDetails'

export default function ChatPage() {
  return (
    <Page title="Conversations">
      <ChatPageDetails />
    </Page>
  )
}
